/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTriangleMinus = createReactComponent("outline", "triangle-minus", "IconTriangleMinus", [["path", { "d": "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0v.001z", "key": "svg-0" }], ["path", { "d": "M9 13h6", "key": "svg-1" }]]);

export { IconTriangleMinus as default };
//# sourceMappingURL=IconTriangleMinus.mjs.map
